import { returnPath } from "~/features/common/utils/navigation/returnPath";

export const getIndexPath = returnPath("/system/agents/timing-service");

export const getIdPath = returnPath("/system/agents/timing-service/:id");
